export default __webpack_public_path__ + "static/media/SAS0060.34I-32434_-17814_0.0bd7f925.jpg";